import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requireOrganization?: boolean;
  requireAIAccess?: boolean;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ 
  children, 
  requireOrganization = false,
  requireAIAccess = false
}) => {
  const { isAuthenticated, isLoading, user, canUseAI } = useAuth();

  // Show loading spinner while checking authentication
  if (isLoading) {
    return (
      <div className="auth-loading">
        <div className="spinner"></div>
        <span>Loading...</span>
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated || !user) {
    return <Navigate to="/app/login" replace />;
  }

  // Redirect to organization setup if organization is required but user doesn't have one
  if (requireOrganization && !user.organization_id) {
    return <Navigate to="/app/setup-organization" replace />;
  }

  // Redirect to main app if AI access is required but user doesn't have permission
  if (requireAIAccess && !canUseAI()) {
    return <Navigate to="/app" replace />;
  }

  return <>{children}</>;
}; 